import { useReducer, useMemo } from "react";
import OrderRequestStateContext from "./OrderRequestStateContext";
import orderRequestInitialState from "./orderRequestInitialState";
import orderRequestStateReducer from "./orderRequestStateReducer";
import orderRequestSessionStorage from "./orderRequestSessionStorage";

export function OrderRequestProvider(props) {
  const { children } = props;
  const [state, dispatch] = useReducer(orderRequestStateReducer, orderRequestInitialState);
  const stateContextMemo = useMemo(() => {
    return {
      state,
      dispatch,
      syncStorage: () => {
        orderRequestSessionStorage().setItem(state.requests);
      },
      setUniqueKey: () => {
        if (state.orderRequestKey === null) {
          // TODO: Find a better way to generate unique key
          dispatch({ type: "SET_ORDER_REQUEST_KEY", payload: Date.now() });
        }
      },
      setOrderRequestStatus: (status) => {
        dispatch({ type: "SET_REQUEST_STATUS", payload: status });
      },
      setCurrentRequest: (requestPayload) => {
        if (state.requests.current === null) {
          dispatch({ type: "SET_CURRENT_REQUEST", payload: requestPayload });
          dispatch({ type: "SET_REQUEST_ERROR", payload: null });
        }
      },
      setRequestError: (err) => {
        dispatch({ type: "SET_REQUEST_ERROR", payload: err });
      },
      setOrderRequestComplete: (requestPayload, error = null) => {
        if (!error) {
          dispatch({
            type: "ADD_SUCCESS_REQUEST",
            payload: {
              payload: requestPayload,
              key: state.orderRequestKey
            }
          });
        } else {
          dispatch({ type: "SET_REQUEST_ERROR", payload: error });
          dispatch({
            type: "ADD_FAILED_REQUEST",
            payload: {
              payload: requestPayload,
              key: state.orderRequestKey,
              error: { message: error?.message || "Unknown Error" }
            }
          });
        }

        dispatch({ type: "SET_CURRENT_REQUEST", payload: null });
      }
    };
  }, [state, dispatch]);

  return (
    <OrderRequestStateContext.Provider value={stateContextMemo}>
      {children}
    </OrderRequestStateContext.Provider>
  );
}
